import React, { FC } from 'react';
import {
  Box, Chip, Stack, Button, Typography,
} from '@mui/material';
import {
  ImgBox,
  Typography700,
} from 'views/rebranded-module/common/components';
import NavigatorLink from 'views/rebranded-module/common/components/Logical/NavigatorLink';
import StyledButtonBase from 'views/rebranded-module/common/components/UI/EventAndRidesCardV2/EventAndRidesCardV2.styles';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import {
  RiStarLine,
  RiMapPin2Line,
  RiCalendar2Line,
  RiArrowRightUpLine,
} from 'react-icons/ri';
import Typography500 from 'views/common/components/UI/Typography500';

// Define image type
interface ImageObject {
  src: string;
  alt: string;
}

// Define link type
interface PathObject {
  pathname?: string;
  href?: string;
  to?: string;
  [key: string]: any;
}

// Define the props interface
interface EventAndRideProps {
  image?: string | ImageObject;
  title: string;
  path: string | PathObject;
  startDateDay?: string;
  startDateMonth?: string;
  isFeatured?: boolean;
  startDate?: string;
  endDate?: string;
  address?: string;
  showBtn?: boolean;
  description?:string;
}

const EventAndRidesCardV2: FC<EventAndRideProps> = (props) => {
  const {
    image,
    title,
    startDateDay,
    startDateMonth,
    path,
    isFeatured,
    startDate,
    endDate,
    address,
    showBtn,
    description,
  } = props;
  const content = useContent('EventRideCardComponent');

  return (
    <StyledButtonBase component={NavigatorLink} href={path}>
      <Stack alignItems="start" width="100%" height="100%">
        <Box className="EARCImgContainer">
          <ImgBox
            image={{
              src: image || 'imgs/Rebranding/logos/default.jpg',
              alt: title,
            }}
            width="100%"
            height="100%"
            objectFit="cover"
            unoptimized
          />
          {isFeatured && (
            <Chip
              icon={<RiStarLine />}
              label={content.featuredLabel}
              color="primary"
              className="EARCFeatured"
            />
          )}
        </Box>
        <Box className="ERCContent">
          <Box className="ERCLeftSideContent">
            <Box width="100%">
              <Box mb={1.5} className="ERCTitleMobileContainer">
                <Typography700 variant="h5" component="p">
                  {title}
                </Typography700>
                {startDateDay && startDateMonth && (
                  <Box className="ERCStartDate showMOBILE">
                    <Typography700 className="ERCMonth" component="p">
                      {startDateMonth}
                    </Typography700>
                    <Typography700 className="ERCDay" component="p">
                      {String(startDateDay).padStart(2, '0')}
                    </Typography700>
                  </Box>
                )}
              </Box>

              {startDate && (
                <Box className="ERCInfoItem" mt={2}>
                  <RiCalendar2Line className="ERCInfoIcon" />
                  <Typography500 variant="body2" className="ERCInfotext">
                    {`${startDate} - ${endDate}`}
                  </Typography500>
                </Box>
              )}
              {address && (
                <Box className="ERCInfoItem" mt={1}>
                  <RiMapPin2Line className="ERCInfoIcon" />
                  <Typography500 variant="body2" className="ERCInfotext">
                    {address}
                  </Typography500>
                </Box>
              )}
              {description && (
              <Typography
                mt={2.5}
               
                className="ERDescription"
                component="p"
                variant="body1"
                color="text.secondary"
                dangerouslySetInnerHTML={{ __html: description }}
                          />
              )}
            </Box>
            {showBtn && (
              <Box className="ERCBtnContainer">
                <Button
                  variant="text"
                  color="secondary"
                  className="ERCBtn"
                  endIcon={<RiArrowRightUpLine />}>
                  {content.learnMoreBtnLabel}
                </Button>
              </Box>
            )}
          </Box>
          {startDateDay && startDateMonth && (
            <Box className="ERCStartDate showTabletAndDesktop">
              <Typography700 className="ERCMonth" component="p">
                {startDateMonth}
              </Typography700>
              <Typography700 className="ERCDay" component="p">
                {String(startDateDay).padStart(2, '0')}
              </Typography700>
            </Box>
          )}
        </Box>
      </Stack>
    </StyledButtonBase>
  );
};

export { EventAndRidesCardV2 };
